import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X, Copy, Check } from 'lucide-react';
import copy from 'copy-to-clipboard';
import LoaderBtn from '../LoaderBtn/LoaderBtn';
import './calltobuymodal.scss';

interface CallToBuyModalProps {
 isOpen: boolean;
 onClose: () => void;
 phoneNumber: string;
 vendorName: string;
}

export const CallToBuyModal = ({
 isOpen,
 onClose,
 phoneNumber,
 vendorName,
}: CallToBuyModalProps) => {
 const [isCopied, setIsCopied] = useState(false);

 const handleCopy = () => {
  if (copy(phoneNumber)) {
   setIsCopied(true);
   setTimeout(() => setIsCopied(false), 2000);
  }
 };

 return (
  <AnimatePresence>
   {isOpen && (
    <motion.div
     className="call-to-buy-modal-overlay"
     initial={{ opacity: 0 }}
     animate={{ opacity: 1 }}
     exit={{ opacity: 0 }}
     onClick={onClose}
    >
     <motion.div
      className="call-to-buy-modal"
      initial={{ scale: 0.9, opacity: 0, y: 20 }}
      animate={{ scale: 1, opacity: 1, y: 0 }}
      exit={{ scale: 0.9, opacity: 0, y: 20 }}
      transition={{ type: 'spring', damping: 25, stiffness: 300 }}
      onClick={(e) => e.stopPropagation()}
     >
      <button
       className="close-btn"
       onClick={onClose}
       aria-label="Close modal"
      >
       <X size={20} />
      </button>

      <div className="modal-header">
       <h2>Call to Buy</h2>
       <p>Contact {vendorName} to complete your purchase</p>
      </div>

      <div className="phone-display">
       <span className="phone-number">{phoneNumber}</span>
       <button
        className="copy-btn"
        onClick={handleCopy}
        title="Copy to clipboard"
       >
        <AnimatePresence mode="wait">
         {isCopied ? (
          <motion.div
           key="check"
           initial={{ scale: 0.5, opacity: 0, rotate: -45 }}
           animate={{ scale: 1, opacity: 1, rotate: 0 }}
           exit={{ scale: 0.5, opacity: 0 }}
           transition={{ duration: 0.2 }}
          >
           <Check
            size={14}
            color="#22c55e"
           />
          </motion.div>
         ) : (
          <motion.div
           key="copy"
           initial={{ scale: 0.5, opacity: 0 }}
           animate={{ scale: 1, opacity: 1 }}
           exit={{ scale: 0.5, opacity: 0 }}
           transition={{ duration: 0.2 }}
          >
           <Copy size={14} />
          </motion.div>
         )}
        </AnimatePresence>
       </button>
      </div>

      <div className="modal-actions has-mobile-call">
       <a
        href={`tel:${phoneNumber}`}
        className="call-btn"
       >
        <LoaderBtn
         className="actbtn full"
         text="Call Now"
         isLoading={false}
         thickness={3}
        />
       </a>
       <LoaderBtn
        className="actbtn open"
        text="Close"
        clickFunction={onClose}
        isLoading={false}
        thickness={3}
       />
      </div>
     </motion.div>
    </motion.div>
   )}
  </AnimatePresence>
 );
};
